import { createApp, h } from 'vue';
import { EventTypes } from './delivery-address-events';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import CurrentDeliveryAddress from './components/current-delivery-address';
import i18n from './vue-deliveryaddress-i18n';

let vueShowDeliveryAddressApp = null;
console.log("subscribing to EventTypes.SHOW_CURRENT_ADDRESS");
PubSub.subscribe(EventTypes.SHOW_CURRENT_ADDRESS, (eventName, params) => {
    if (vueShowDeliveryAddressApp !== null) {
        if (vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressTargetSelector == params.targetSelector) {
            PubSub.publish("DeliveryAddress.ShowDeliveryAddressApp");
            return;
        }
        else vueShowDeliveryAddressApp.unmount(); 
    }
        
    if (params.RegistrationVM === undefined || params.RegistrationVM === null)
        return;


    vueShowDeliveryAddressApp = createApp({
        components: { 'current-delivery-address': CurrentDeliveryAddress },
        render: () => h(CurrentDeliveryAddress),
    });
    vueShowDeliveryAddressApp.use(i18n);
    vueShowDeliveryAddressApp.use(ToastPlugin, {
        duration: 5000,
        position: 'bottom-right'
    });
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressDeleteActive = params.isDeleteActive;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressTargetSelector = params.targetSelector;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressIsPreview = params.isPreview;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressDeleteTargetSelector = params.deleteTargetSelector;
    vueShowDeliveryAddressApp.config.globalProperties.$currentDeliveryAddressIsReadOnly = params.isReadOnly;    
    vueShowDeliveryAddressApp.config.globalProperties.$registrationVm = params.RegistrationVM;
    if (jQuery("#delivery-address-delete-info-placeholder").length <= 0) {
        console.log("delivery-address-delete-info-placeholder not found");
    }
    vueShowDeliveryAddressApp.mount("#vue-app-plch");    
    params.RegistrationVM.deliveryAddressVueApp = vueShowDeliveryAddressApp;
});
